import { render, staticRenderFns } from "./ProfileEmail.vue?vue&type=template&id=35dbb2dc&"
import script from "./ProfileEmail.vue?vue&type=script&lang=js&"
export * from "./ProfileEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../build/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports